var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-1"},[_c('Menu'),_c('div',{staticClass:"parent"},[_c('iframe',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoaded),expression:"isLoaded"}],staticClass:"iframe-container",attrs:{"src":_vm.gameURL}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }